import React from 'react';
import { Stepper, Step, StepLabel, styled } from '@mui/material';
import './statusIndicator.scss';

export interface StatusItem {
  label: string;
  completed: boolean;
  active: boolean;
}

interface StatusIndicatorProps {
  statuses: StatusItem[];
  className?: string;
}

// Custom styled components for MUI Stepper
const CustomStepper = styled(Stepper)(({ theme }) => ({
  backgroundColor: '#f5f7f7',
  borderRadius: '4px',
  padding: '8px 12px',
  width: '100%',
}));

const CustomStepLabel = styled(StepLabel)(({ theme }) => ({
  '& .MuiStepLabel-label': {
    fontFamily: 'Calibre-R, -apple-system, Roboto, Helvetica, sans-serif',
    fontSize: '14px',
    fontWeight: 400,
    color: '#1a1a1a',
  },
}));

const StatusIndicator: React.FC<StatusIndicatorProps> = ({ statuses, className = '' }) => {
  // Find the active step index
  const activeStep = statuses.findIndex(status => status.active);

  return (
    <div className={`status-indicator ${className}`}>
      <CustomStepper activeStep={activeStep} alternativeLabel={false} connector={<StepConnector />}>
        {statuses.map((status, index) => (
          <Step key={index} completed={status.completed}>
            <CustomStepLabel
              StepIconComponent={index === activeStep ? ActiveStepIcon : DefaultStepIcon}
            >
              {status.label}
            </CustomStepLabel>
          </Step>
        ))}
      </CustomStepper>
    </div>
  );
};

// Custom step icons
const ActiveStepIcon = () => <div className="active-step-icon"></div>;
const DefaultStepIcon = () => <div className="default-step-icon"></div>;

// Custom connector
const StepConnector = () => <div className="step-connector"></div>;

export default StatusIndicator;
